export default {
  tile: window.innerWidth >= 768 ? 50 : 30,
  stage: { width: 30, height: 25 },
};
